import { Group, Paper, Pill, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { TitleCard } from '@/core/components';

import { Award } from './../../model/AwardTypes';
import classes from './AwardCard.module.css';

export interface AwardCardProps {
  award: Award;
  to?: string;

  onClick?: () => void;
}

export function AwardCard({ award, to, onClick }: AwardCardProps) {
  const { title, awardedFor, year, type, contribution, institution, activity, conference } = award;

  return (
    <Paper
      className={classes.card}
      component={to ? Link : undefined}
      to={to}
      onClick={onClick}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="12px">
        <TitleCard title={`${title} (${year})`} />
        {conference && <Text size="sm">{conference?.name}</Text>}
        <Group>
          <Pill>Pentru: {awardedFor?.name}</Pill>
          <Pill>Tip: {type?.name}</Pill>
          <Pill>Contribuție: {contribution?.name}</Pill>
          <Pill>Institutie: {institution?.name}</Pill>
          <Pill>Activitate: {activity?.name}</Pill>
        </Group>
      </Stack>
    </Paper>
  );
}
